@if (!isLoaded || isMenuClosed || isConnectionError) {
  <div (click)="hideSplash()" class="splash-screen">

    @if (isConnectionError) {
      <div class="connection-error-message">
        <p>{{ 'COMMON.CONNECTION_ERROR' | translate }}</p>
        <button class="btn" mat-raised-button (click)="retry()">
          <span>{{ 'ACTIONS.RETRY' | translate }}</span>
        </button>
      </div>
    } @else if (isMenuClosed) {
      @if (imageSrc) {
        <img class="splash-screen-icon loaded" [src]="imageSrc" (load)="markLoaded()">
      } @else {
        <div class="menu-closed-message">
          @for (lang of languages; track lang) {
            <p>{{ menuClosedMessage[lang] || '' }}</p>
          }
        </div>
      }
    } @else {
      <img [ngClass]="{loaded: imageSrc && imagesLoadedCount >= 2}" 
           class="splash-screen-icon" 
           [defaultImage]="'opaala-splash.svg' | themeSource" 
           [lazyLoad]="imageSrc ? imageSrc : ('opaala-splash.svg' | themeSource)" 
           (load)="markLoaded()">
      @if (imageSrc && imagesLoadedCount >= 2) {
        <button class="btn" mat-raised-button (click)="hideSplash()">
          <span>{{ 'MENU.SKIP' | translate }}</span>
        </button>
      }
    }

  </div>
}